import { Yup } from "components/DynamicForm/utils";

const form = {
    sections: [{
        fields: [
            [
                {
                    "type": "email",
                    "name": "email",
                    "validation": Yup.string().email().required(),
                    "description": "Email del usuario",
                    "label": "Email",
                    "sizing": {
                        "sm": 6
                    }
                }
            ]
        ]
    }]
};


export default form;